<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-6 col-lg-8 col-md-8">
                                                <div class="submit-field">
                                                    <h5>Nome</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o nome..." v-model="form.nome">
                                                </div>
                                            </div>

                                            <div class="col-xl-6 col-lg-8 col-md-6">
                                                <div class="submit-field">
                                                    <h5>E-mail</h5>
                                                    <input type="email" class="with-border" placeholder="Informe o e-mail aqui" v-model="form.email">
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-8 col-lg-4 col-md-4">
                                                <div class="submit-field">
                                                    <h5>Telefone</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                                </div>
                                            </div>
                                            <div class="col-xl-3 col-xs-8 col-lg-4 col-md-4">
                                                <div class="submit-field">
                                                    <h5>Telefone fixo</h5>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefoneFixo" />
                                                </div>
                                            </div>                                            
                                            
                                            <div class="col-xl-4 col-xs-10 col-lg-5 col-md-5">
                                                <div class="submit-field">
                                                    <h5>CNPJ:</h5>
                                                    <the-mask :mask="['##.###.###/####-##']" class="with-border" type="tel" v-model="form.doc" placeholder="__.___.___/____-__" />
                                                </div>
                                            </div>

                                            <!-- <div class="col-xl-12 clearfix"></div> -->

                                            <div class="col-xl-3 col-lg-4 col-md-4">
                                                <div class="submit-field">
                                                    <h5>Inscrição estadual</h5>
                                                    <input type="text" class="with-border" placeholder="" v-model="form.inscricaoEstadual">
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-md-3 col-lg-3 col-xs-7 col-md-4">
                                                <div class="submit-field">
                                                    <h5>Código ANP</h5>
                                                    <input type="text" class="with-border" placeholder="" v-model="form.codAnp">
                                                </div>
                                            </div>                                                                          

                                            <div class="col-xl-2 col-md-2 col-lg-2 col-xs-5 col-md-3">
                                                <div class="submit-field">
                                                    <h5>Nº das ordens</h5>
                                                    <input type="text" class="with-border" placeholder="" v-model="form.pedidosNumeroInicio">
                                                </div>
                                            </div>                                                                          

                                        </div>
                                    </div>
                                </div>


                            </div>

                            <div class="col-xl-12">
                                <div class="dashboard-box">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">place</i> Endereço</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">
                                        <div class="row">
                                            <div class="col-xl-10 col-lg-10 col-md-9">
                                                <div class="submit-field">
                                                    <h5>Rua</h5>
                                                    <input type="text" class="with-border" placeholder="Endereço" v-model="form.endereco">
                                                </div>
                                            </div>

                                            <div class="col-xl-2 col-xs-5 col-lg-2 col-md-3">
                                                <div class="submit-field">
                                                    <h5>Número</h5>
                                                    <input type="tel" class="with-border" placeholder="" v-model="form.numero">
                                                </div>
                                            </div>

                                            <div class="col-xl-9 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Complemento</h5>
                                                    <input type="text" class="with-border" placeholder="" v-model="form.complemento">
                                                </div>
                                            </div>
                                    
                                            <div class="col-xl-3 col-xs-7 col-lg-4 col-md-4">
                                                <div class="submit-field">
                                                    <h5>CEP</h5>
                                                    <the-mask :mask="['#####-###']" :masked="true" type="tel" class="with-border" v-model="form.cep" placeholder="Informe o CEP" />
                                                </div>
                                            </div>
                                    
                                            <div class="col-xl-4 col-lg-6 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Bairro</h5>
                                                    <input type="text" class="with-border" placeholder="Informe o bairro" v-model="form.bairro">
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-lg-6 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Cidade</h5>
                                                    <input type="text" class="with-border" id="cidade" placeholder="Informe o cidade" v-model="form.cidade">
                                                </div>
                                            </div>

                                            <div class="col-xl-4 col-lg-6 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Estado</h5>
                                                    <select id="estado" readonly="" class="with-border" name="estado" required="" v-model="form.estado">
                                                        <option value="" disabled selected hidden>Selecione o estado</option>
                                                        <option value="AC">Acre</option>
                                                        <option value="AL">Alagoas</option>
                                                        <option value="AP">Amapá</option>
                                                        <option value="AM">Amazonas</option>
                                                        <option value="BA">Bahia</option>
                                                        <option value="CE">Ceará</option>
                                                        <option value="DF">Distrito Federal</option>
                                                        <option value="ES">Espírito Santo</option>
                                                        <option value="GO">Goiás</option>
                                                        <option value="MA">Maranhão</option>
                                                        <option value="MT">Mato Grosso</option>
                                                        <option value="MS">Mato Grosso do Sul</option>
                                                        <option value="MG">Minas Gerais</option>
                                                        <option value="PA">Pará</option>
                                                        <option value="PB">Paraíba</option>
                                                        <option value="PR">Paraná</option>
                                                        <option value="PE">Pernambuco</option>
                                                        <option value="PI">Piauí</option>
                                                        <option value="RJ">Rio de Janeiro</option>
                                                        <option value="RN">Rio Grande do Norte</option>
                                                        <option value="RS">Rio Grande do Sul</option>
                                                        <option value="RO">Rondônia</option>
                                                        <option value="RR">Roraima</option>
                                                        <option value="SC">Santa Catarina</option>
                                                        <option value="SP">São Paulo</option>
                                                        <option value="SE">Sergipe</option>
                                                        <option value="TO">Tocantins</option>
                                                    </select>                                                   
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </div>                                                                      
                                </div>
                            </div>  

                            <div class="col-xl-12">
                                <div class="hidden-xs clearfix margin-top-30"></div>
                                <button type="submit" class="button ripple-effect big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                    <i class="material-icons">save</i>
                                  {{ form.cod ? 'Salvar filial' : 'Cadastrar filial' }}
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'GerenciarEmpresas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "email":            "",
                "telefone":         "",
                "telefoneFixo":     "",
                "inscricaoEstadual":"",
                "codAnp":           "",
                "estado":           "",
                "endereco":         "",
                "complemento":      "",
                "numero":           "",
                "cep":              "",
                "bairro":           "",
                "cidade":           "",
                "doc":              "",
                "pedidosNumeroInicio":""
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/empresas.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        init: function() {
            var self = this;
            if (self.$route.name == "EditarEmpresas") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                self.form.cod = self.$route.query.c;
                self.get();
            } else {
                loading.hide();
            }            
        }    
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }        
    },
    mounted: function() {
    }     
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarEmpresas.vue